import { render, staticRenderFns } from "./DownloadShowcase.vue?vue&type=template&id=567ece4a"
import script from "./DownloadShowcase.vue?vue&type=script&lang=js"
export * from "./DownloadShowcase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports